// extracted by mini-css-extract-plugin
export default {"bpTablet":"950px"};